import type { ReactNode } from "react";

import type { CarrierPrice } from "~/shared/schemas/carrier-schema.ts";

import { CarrierRoutingGuideInfo } from "../components/carrier-routing-guide-info.tsx";

type CarrierBannerResult = {
	banner: ReactNode;
	bannerClassName: string | undefined;
};

const getBannerText = (
	carrierPrice: CarrierPrice,
	bannerType: string | null,
): string => {
	const qualifier = bannerType === "toggle" ? "" : "originally ";
	return `${carrierPrice.carrier.displayName} was ${qualifier}filtered out due to Routing Guide Rules.`;
};

export function useCarrierBanner(
	bannerType: string | null,
	carrierPrice: CarrierPrice,
): CarrierBannerResult {
	if (
		!bannerType ||
		carrierPrice.routingGuideApplied ||
		carrierPrice?.carrierPriceType?.name?.toLowerCase() === "manual"
	) {
		return { banner: null, bannerClassName: undefined };
	}

	const bannerText = getBannerText(carrierPrice, bannerType);
	const bannerModifier =
		bannerType === "viewHidden" ? "view-hidden" : bannerType;

	const banner = (
		<span>
			{bannerText}{" "}
			<CarrierRoutingGuideInfo
				carrierName={carrierPrice.carrier.displayName ?? ""}
				ruleNames={
					carrierPrice.routingGuideEvaluatedName
						? carrierPrice.routingGuideEvaluatedName.split(",")
						: []
				}
			/>
		</span>
	);

	return {
		banner,
		bannerClassName: `banner-${bannerModifier}`,
	};
}
